import React from "react";
import { Mascot } from "./Mascot";
import { ShieldCheck, Zap } from "lucide-react";

export const Footer = () => (
  <footer className="py-14 brutal-border-y bg-black" data-testid="footer">
    <div className="max-w-7xl mx-auto px-5 md:px-10 grid grid-cols-1 md:grid-cols-3 gap-10">
      <div className="flex items-start gap-4">
        <Mascot size={64} />
        <div>
          <div className="heading text-xl">THE DOHERTY DOSSIER</div>
          <div className="font-mono text-[11px] text-white/60 uppercase">
            A tabloid for the terminally online
          </div>
        </div>
      </div>

      <div className="space-y-4">
        <div className="font-mono text-[11px] uppercase tracking-widest text-[#FFEA00]">
          Accuracy Legend
        </div>
        <div className="flex items-start gap-3">
          <span
            className="inline-flex items-center gap-1 px-2 py-1 brutal-border font-mono text-[10px] font-bold uppercase shrink-0"
            style={{ background: "#00FF00", color: "#000", borderWidth: 3 }}
          >
            <ShieldCheck size={12} strokeWidth={3} />
            VERIFIED
          </span>
          <p className="text-xs text-white/70">
            Widely reported with primary sources. Dates and quotes checkable.
          </p>
        </div>
        <div className="flex items-start gap-3">
          <span
            className="inline-flex items-center gap-1 px-2 py-1 brutal-border font-mono text-[10px] font-bold uppercase shrink-0"
            style={{ background: "#FFEA00", color: "#000", borderWidth: 3 }}
          >
            <Zap size={12} strokeWidth={3} />
            PATTERN
          </span>
          <p className="text-xs text-white/70">
            Directionally true behavior pattern. Specific dates or numbers are
            stylized for comedic effect.
          </p>
        </div>
      </div>

      <div className="space-y-3">
        <div className="font-mono text-[11px] uppercase tracking-widest text-[#FF003C]">
          Parody Notice
        </div>
        <p className="text-xs text-white/70 leading-relaxed">
          This site is a satirical roast of a public internet personality.
          Descriptions are written for comedic effect. Clip links point to
          public searches and reporting. No affiliation, no endorsement. If
          this is you reading this: hi, maybe log off.
        </p>
        <div className="font-mono text-[10px] text-white/40 pt-2">
          © {new Date().getFullYear()} HALL OF SHAME · Printed on neon paper
        </div>
      </div>
    </div>
  </footer>
);
